import React from "react";

/** When given a string containing new line characters, returns a React Fragment (and children) containing the text with
 * new line characters converted to BR elements
 */
export function convertNewLinesToBr(text: string) {
  const [firstLine, ...otherLines] = text.split('\n');
  return (
    <>
      {firstLine}
      {otherLines.map((item, index) => (
        <React.Fragment key={index}>
          <br />
          {item}
        </React.Fragment>
      ))}
    </>
  );
}